/*@ngInject*/
const ForgotPasswordController = function ($scope, $uibModalInstance, modalUtil, coreMediator, localization) {

    localization.setupLocale('auth', require('./forgotPassword.i18n.json'));

    $scope.viewModel = {
        username: null,
        emailAddress: null
    };

    $scope.forgotPassword = function () {
        if ($scope.validateFields()) {
            coreMediator.forgotPassword($scope.viewModel.username, $scope.viewModel.emailAddress);

            $uibModalInstance.close();
            modalUtil.showGenericConfirm({
                title:  i18n.t('auth|forgotPassword.title'),
                summary: i18n.t('auth|forgotPassword.summary'),
                confirmActionButtonLabel: i18n.t('auth|forgotPassword.okButton')
            });
        }
    };

    $scope.validateFields = function () {
        return $scope.viewModel.username && $scope.viewModel.emailAddress;
    };
};

angular.module('gw-um-auth')
    .controller('forgotPasswordController', ForgotPasswordController);
